// import types
import JwtToken from '@/composables/useToken/types/JwtToken';

export default function useToken() {
  function isExpired(token: string) {
    const jwtToken = token ? JSON.parse(atob(token.split('.')[1])) : '';
    const tokenExpired = Date.now() > jwtToken.exp * 1000;

    if (tokenExpired) {
      return true;
    }
    return false;
  }

  function decodeToken(token: string): JwtToken {
    const decodedToken: JwtToken = {
      aud: '',
      exp: 0,
      role: '',
      name: '',
      nameIdentifier: '',
      iss: '',
      jti: '',
      sub: '',
    };
    // decode the token
    const jwtBase64 = token.split('.')[1];
    const jwtToken = JSON.parse(atob(jwtBase64));

    // set the decoded token values
    decodedToken.aud = jwtToken.aud;
    decodedToken.exp = jwtToken.exp;
    decodedToken.role =
      jwtToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    decodedToken.name =
      jwtToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    decodedToken.nameIdentifier =
      jwtToken[
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'
      ];
    decodedToken.iss = jwtToken.iss;
    decodedToken.jti = jwtToken.jti;
    decodedToken.sub = jwtToken.sub;

    return decodedToken;
  }

  return {
    isExpired,
    decodeToken,
  };
}
